import React from 'react';
import styled, { keyframes } from 'styled-components';
import { SignInButton } from '@clerk/clerk-react';

const fadeIn = keyframes`
  from { 
    opacity: 0;
    transform: translateY(20px);
  }
  to { 
    opacity: 1;
    transform: translateY(0);
  }
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background-color: #F5F5F7;  /* Apple light background */
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
`;

const Card = styled.div`
  background-color: white;
  border-radius: 16px;
  padding: 3rem;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.06);
  text-align: center;
  max-width: 500px;
  width: 90%;
  animation: ${fadeIn} 0.8s cubic-bezier(0.25, 0.8, 0.25, 1);
`;

const Title = styled.h1`
  color: #1D1D1F;
  margin-bottom: 1rem;
  font-size: 2rem;
  font-weight: 600;
  letter-spacing: -0.02em;
`;

const Description = styled.p`
  color: #86868B;
  margin-bottom: 2.5rem;
  font-size: 1.1rem;
  line-height: 1.6;
`;

const StyledButton = styled.button`
  background-color: #007AFF;  /* Apple blue */
  color: white;
  border: none;
  border-radius: 12px;
  padding: 0.9rem 2.5rem;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  
  &:hover {
    background-color: #0062CC;  /* Darker blue */
    transform: translateY(-2px);
    box-shadow: 0 5px 15px rgba(0, 122, 255, 0.2);
  }
  
  &:active {
    transform: translateY(0);
  }
`;

const LoginPrompt = () => {
  return (
    <Container>
      <Card>
        <Title>Task Manager</Title>
        <Description>
          Please sign in to access the Task Manager. This feature helps you organize your tasks and increase productivity.
        </Description>
        <SignInButton mode="modal">
          <StyledButton>Sign In</StyledButton>
        </SignInButton>
      </Card>
    </Container>
  );
};

export default LoginPrompt; 